module.exports = __webpack_public_path__ + "static/media/Background_5.105a8ac6.svg";